import { fetchJson, path } from './client'
import type { Job } from '@/schema/jobs'
import type { VideoOptions } from '@/player/videoOptions'

export interface VideoResult {
  url?: string
  duration_s?: number
  elapsed_ms?: number
  timings_ms?: Record<string, number>
  options?: VideoOptions
}

export function startVideoExport(uid: string, options: VideoOptions): Promise<{ job_id: number }> {
  return fetchJson(path`/api/stories/${uid}/video-export`, { method: 'POST', body: options })
}

export function latestVideoExport(uid: string, signal?: AbortSignal): Promise<{ job: Job | null }> {
  return fetchJson(path`/api/stories/${uid}/video-export`, { signal })
}
